export const PIECE_TAG = 'pappers-piece';
const PIECE_TAG_PREFIX = `${PIECE_TAG}:`;

// Same rule as the API's `z.uuid()` check: RFC 9562 version 1 to 8, RFC variant
const PIECE_ID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Tells whether a value has the shape of a document ID the API accepts.
 * Use it on IDs that do not come from the API, such as IDs written by the model in a statement of facts.
 */
export const isPieceId = (value: string): boolean => PIECE_ID_REGEX.test(value);

/**
 * Returns the piece ID stored in a content control tag, or null when the tag is not a piece tag
 * or holds a malformed ID. Controls with a malformed ID are then left out of numbering and API sync.
 */
export const pieceIdFromTag = (tag: string): string | null => {
	if (!tag.startsWith(PIECE_TAG_PREFIX)) {
		return null;
	}
	const pieceId = tag.slice(PIECE_TAG_PREFIX.length);
	return isPieceId(pieceId) ? pieceId : null;
};
